import React, { memo } from 'react';

import { Box } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize, LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { COMMON_DATE_FORMAT } from 'constants/date';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';

const EcdChip = ({ earliestClosingDate }) => {
  if (!earliestClosingDate) {
    return null;
  }

  const title = `Earliest closing ${dayjs(earliestClosingDate).format(COMMON_DATE_FORMAT)}`;

  return (
    <Box data-testid={DisclosureDeliveryTestIds.ECD_CHIP}>
      <LabelCDS size={LabelSize.S} title={title} variant={LabelVariant.BLUE} />
    </Box>
  );
};

EcdChip.propTypes = {
  earliestClosingDate: PropTypes.string,
};

export default memo(EcdChip);
